import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import axios from 'axios'
import Modal from 'react-modal'

import FaPlus from 'react-icons/fa/plus'
import FaClose from 'react-icons/fa/times-circle'

@autobind
class WorkResourcesSeed extends Component {
  constructor (props) {
    super(props)
    this.state = {showModal: false, resource: '', posting: false}
    axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector('meta[name=csrf-token]').getAttribute('content')
  }

  componentWillMount () {
    Modal.setAppElement('body')
  }

  handleOpenModal (workdId, lessonIndex) {
    this.setState({showModal: true})
  }

  handleCloseModal () {
    this.setState({showModal: false, resource: ''})
  }

  handleResource (event) {
    this.setState({resource: event.target.value})
  }

  addResourceToLesson (event) {
    event.preventDefault()
    this.setState({posting: true})
    axios.post(
      `/api/v1/lessons/${this.props.lessonId}/teaching_resources`,
      {teaching_resource: {id: this.state.resource}}
    )
    .then(response => {
      // this.props.onResourceAddition(response.data)
      // We need an API response to make this work ^
      this.handleCloseModal()
    })
    .catch(() => {
      alert('Oops! Something went wrong.')
      this.setState({posting: false})
    })
  }

  render () {
    return (
      <div className='workMedia__resourcesSeed'>
        <button className='btn btn-overlay' onClick={this.handleOpenModal}><FaPlus /> Resource</button>
        <Modal isOpen={this.state.showModal} contentLabel='Add a resource to this lesson' onRequestClose={this.handleCloseModal} overlayClassName='modal fade in' style={{content: {background: 'transparent', border: 'none'}}}>
          <div className='modal-dialog modal-dialog--small'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h4 className='modal-title'>Add a resource to this lesson</h4>
                <span className='modal__close' onClick={this.handleCloseModal}>
                  <FaClose />
                </span>
              </div>
              <div className='modal-body'>
                <div className='form-group'>
                  <label htmlFor='resourceId'>Enter the resource id:</label>
                  <input type='text' className='form-control' id='resourceId' onChange={this.handleResource} />
                </div>
              </div>
              <div className='modal-footer'>
                <button type='button' className='btn btn-link' onClick={this.handleCloseModal}>Cancel</button>
                <button type='button' className='btn btn-primary' onClick={this.addResourceToLesson} disabled={this.state.resource === '' || this.state.posting}>Add</button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

WorkResourcesSeed.propTypes = {
  lessonId: PropTypes.number
  // onResourceAddition: PropTypes.func
}

export default WorkResourcesSeed



// WEBPACK FOOTER //
// ./components/work/WorkResourcesSeed.js